<template>
    <div class="label__emit--wrap" :class="disabled ? 'disabled' : ''">
        <label class="label__emit--button gray">
            <span>Choisir</span>
            <input type="file" class="import-button" :disabled="isApproved" hidden enctype="multipart/form-data" @change="handleFileChange" :accept="allowedFileExtensions">
        </label>
        <div class="label__emit__block" :class="{'file-exist col-6': fileExist}">
            <span class="label__emit__block--placeholder" v-if="afterUploaded">Choisir un document</span>
            <span class="label__emit__block--placeholder" v-else-if="value">{{value.name}}</span>
            <span class="label__emit__block--placeholder" v-else-if="options.currentFile">{{options.currentFile.toLowerCase()}}</span>
            <span class="label__emit__block--placeholder" v-else>{{ options.name }}</span>
        </div>
        <div v-if="fileExist" class="portlet__head--button-group col-3">
            <button v-if="!isBusy" class="orange-button" :disabled="!validFileUpload"  @click="uploadDocument()">
                <span>Ajouter</span>
            </button>
            <button v-else class="orange-button" disabled="true">
                <span>Uploading</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import {validationMixin} from 'vuelidate'

    export default {
        props: {
            value: File,
            options: Object,
            disabled: Boolean,
            allowedFileExtensions: {
                type: String,
                default: 'image/jpeg, image/jpg, image/png, image/gif, application/pdf',
            },
            isApproved: Boolean,
            currentDocType: {
                type: String,
                default: ''
            },
            clientID: Number
        },
        data() {
            return {
                file: null,
                type: '',
                isBusy: false,
                afterUploaded: false
            }
        },
        mixins: [
            validationMixin
        ],
        methods: {
            handleFileChange(e) {
                let file = e.target.files[0];
                this.$emit('input', file);
                this.file = file;
                this.type = file.type;
                this.afterUploaded = false;
            },
            uploadDocument() {
                if(!this.$v.file.$invalid) {
                    this.isBusy = true;
                    let url = 'verification_documents/create_client',
                        data = {
                            file: this.file,
                            type: this.type,
                            document_type: this.currentDocType,
                            client_id: this.clientID
                        };

                    this.apiFile(url, data)
                        .then(response => {
                            this.afterUploaded = true;
                            this.options.hash = response.data.token;
                            this.showSuccessNotification('Votre document a bien été uploadé avec succès.');
                            this.$emit('verification_documents_uploaded', {verification_documents: response.data.verification_documents});
                            // this.$store.dispatch('updateRepresentativeVerificationDocuments', response.data.verification_documents);
                            this.clearFields();
                            this.isBusy = false;
                            // this.$router.push(`/signed-membership-import/${this.clientID}`);
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isCommentSendBusy = false;
                        })
                } else {
                    this.showWarningNotification('Please fill all required fields')
                }
            },
            clearFields() {
                // console.log('CLEAR FIELDS');
                this.file = null;
                this.type = '';
                this.options.currentFile = false;
                this.options.hash = null;
                this.options.name = 'Choisir un document';
                this.options.placeholder = true;
            },
            openPreviewDocument() {
              this.isBusy = true;
              let url = 'verification_documents/file-preview';
              this.apiGet(url, {
                hash: this.options.hash,
                type: this.options.type,
              }).then(response => {
                this.isBusy = false;
                console.log(response);
                if (response.data && response.data.url) {
                  window.open(response.data.url);
                }
              }).catch(error => {
                this.isBusy = false;
                this.showErrorNotification(error)
              })
            }
        },
        computed: {
            fileExist() {
              // console.log('fileExist');
              // console.log(this.file);
              // console.log(`options.name ---> ${this.options.name}`);
              if (this.afterUploaded) {
                  return false;
              }
                return !!this.value || this.options.currentFile || this.options.hash;
            },
            validFileUpload() {
                if (this.afterUploaded) {
                    return false;
                }
                return !!this.file;
            },
        },
        validations: {
            file: {
                required
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Clients/Documents/ClientFileInput.vue